import { ImpactModule } from 'types'

export const UNIFIED_LOGIN_MODULE: ImpactModule = {
  NAME: 'UNIFIED_LOGIN',
  NAME_PTBR: 'Login Unificado',
  UPPER_NAME: 'UNIFIED_LOGIN',
  API_NAME: 'ACCOUNT',
}
